import React from 'react'
import { MdOutlineBubbleChart } from "react-icons/md";

const Loading = ({setLoading}) => {

    const loadingIcon = {
        fontSize: '2em',
        color: 'var(--black)',
      };
    
      const loadingOuter = {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        alignContent: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        zIndex: '9999',
        color: 'var(--black)',
        backgroundColor: 'rgba(190, 189, 189, 0.11), 0.1)',
      };

  return (
    <>
      <div style={loadingOuter}>
        <MdOutlineBubbleChart className='animate__animated animate__rotateIn animate__infinite' style={loadingIcon} />
      </div>
    </>
  )
}

export default Loading
